<div class="dialog-padding">
  <app-add-payment-account
    [isEditMode]="data.isEditMode"
    [paymentAccount]="data.paymentAccount"
    [submittingPaymentAccount]="isActionsDisabled$ | async"
    [cardTypes]="cardTypes$ | async"
    (cancel)="handleCancelEditPaymentAccount()"
    (delete)="handleDeletePaymentAccount()"
    (create)="handleCreatePaymentAccount($event)"
    (update)="handleUpdatePaymentAccount($event)"
  ></app-add-payment-account>
</div>
